import { ReactNode } from "react";
import { useSession } from "@supabase/auth-helpers-react";
import { Navigate, useLocation } from "react-router-dom";

type Props = { children: ReactNode };

export default function RequireAuth({ children }: Props) {
  const session = useSession();
  const location = useLocation();

  if (!session) {
    // Preserve where the user was going
    const to = `/auth?redirect=${encodeURIComponent(location.pathname + location.search)}`;
    return <Navigate to={to} replace />;
  }

  return <>{children}</>;
}
